import { BMotion2 } from './BMotion2';
import { BMotionType } from './BMotionEnums';
import { MathFunc } from '../Graphics/MathFunc';
import { KeyFrame } from '../KeyFrame/KeyFrame';

interface RotateKeyFrame extends KeyFrame{
    angle: number
}

export class Rotate extends BMotion2{
    readonly TYPE: BMotionType = BMotionType.ROTA

    constructor(){
        super();
        this.createNewKeyFrame(0, [0]);
        this.prepare();
        /*this.addKeyFrame(360, 48, true);
        this.addKeyFrame(180, 72, true);*/
        //this.addKeyFrame(180, 48, true);
    }

    interpolate(interpolant : number, prev: RotateKeyFrame, next: RotateKeyFrame) : Array<number>{
        var angle = MathFunc.interpolate(
            prev.angle,
            next.angle,
            interpolant);
        return [angle];
    }

    //override
    protected resetComputedVal(){
        this._computedVal = [(this.keyFrames.get(0) as RotateKeyFrame).angle];
    }

    protected updateKeyFrameVal(frameNumber: number, newValue: number[]): void {
        //Parent checks if frame is available before call this method. So key frame is guaranteed to be available.
        (this.keyFrames.get(frameNumber) as RotateKeyFrame).angle = newValue[0];
    }
    protected createNewKeyFrame(frame: number, newValue: number[]): void {
        var angle = newValue[0];
        var interpolate = true;
        let keyFrame = {angle, frame, interpolate}
        this.keyFrames.add(frame, keyFrame)
    }

    clone(): BMotion2{
        var clone = new Rotate()
        super.duplicate(clone);
        for(var keyFrame of this.keyFrames.getKeys()){
            var tkf = this.keyFrames.get(keyFrame) as RotateKeyFrame;
            clone.updateKeyFrame(keyFrame, [tkf.angle]);
        }
        return clone;
    }
}